// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4281":"20bb850763d02c0f","4695":"1e0393235cc5ab4d","5818":"b4b23dddb54ebbd0","5865":"9230d429f95ff80e","9273":"eb6b1980e48d91dd"}[chunkId] + ".css";
};